/**
 * 스크롤 애니메이션 기본 속도 설정
 */
// eslint-disable-next-line import/prefer-default-export
export const FadeUpMixin = {
  data() {
    return {
      duration: 1200,
    };
  },
};
